import { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { accountActions } from '../../action/AccountAction';
import breakdownlst from './pricebreakdown.json';
import { commonClass } from '../../helpers/commonClass';
import io from 'socket.io-client';

class WinnerScroll extends Component {
    constructor(props) {
        super(props);
        this.state = { LiveWinnerLastLst: [], curr_timeout: 1 };

    }
    toConnectWithServer = () => {
        const socket = io(process.env.REACT_APP_SOCKET_SERVER_IP, {
            // const socket = io('https://socket.starteams.in', {

        });

        socket.on('firsttimedata', (data) => {
            this.loadWinnerInfoCreate(data);
            this._bingwinScroll(this.state.LiveWinnerLastLst);
        });

        socket.emit('needaalldata');
        socket.on('winner_update', (data) => {
            this.loadWinnerInfoCreate(data);
        });
    }

    componentDidMount() {
        this.toConnectWithServer();
        this.loadWinnerInfo();
    }

    loadWinnerInfoCreate = (data) => {
        if (!data || data.length <= 0) {
            return;
        }
        let gtWinnerLsit = [];
        data.forEach(element => {
            let str1 = element.winner_info.split('^');
            let str2 = str1[0].split('|');
            let sLst = [];
            str2.forEach(ele => {
                let eleArr = ele.split('~');
                sLst.push({
                    LeftStr: eleArr[0],
                    RightStr: eleArr[1],
                })
            });
            let gtWinner = { data: sLst };
            gtWinnerLsit.push(gtWinner);
        });
        this.state.LiveWinnerLastLst = gtWinnerLsit;
    }

    loadWinnerInfo = () => {
        setInterval(() => {
            setTimeout(() => {
                this._bingwinScroll(this.state.LiveWinnerLastLst);
            }, (this.state.curr_timeout * 1000));
            this.state.curr_timeout = this.state.LiveWinnerLastLst.length;
        }, (30 * 1000));//30sec
    }

    _bingwinScroll = (dd) => {
        let dstr = "<ul class='scrollTop'>"
        dd.forEach(ele => {
            dstr += "<li class='liveWinerCntInnerLi' style='display: none'>"
                + "<div class='liveNameImg'><img src='./assets/img/icons/prizes.png' /></div>"
                + "<div class='liveName'>";
            {
                ele.data.map((x1, inx) =>
                    dstr += "<span>" + x1.LeftStr + "</span>"
                )
            }
            dstr += "</div>"
                + "<div class='liveNameRgt'>"
            {
                ele.data.map((x1, inx) =>
                    dstr += "<span>" + x1.RightStr + "</span>"
                )
            }
            dstr += "</div></li>"
        })
        dstr += "</ul>";
        if (document.getElementById("myscrollTop")) {
            document.getElementById("myscrollTop").innerHTML = dstr;
        }
        setTimeout(() => {
            window.loadWinnerScroll();
        }, 200);
    }

    render() {
        const { t, i18n } = this.props;
        return (
            <div class="liveWinerCnt">
                <div class="liveWinerCntInr">
                    <h2><img src="./assets/img/icons/tropy.png" />{t('lbllivewinner')}</h2>
                    <div id="myscrollTop">
                        <ul className="scrollTop">

                        </ul>
                    </div>
                </div>
            </div>
        )
    }

}
function mapStateToProps(state) {
    const { breakdownlist } = state.accountReducer;
    const { user, appvariables } = state.loginReducer;
    return { user, breakdownlist, appvariables };
}
const mapActionToProps = {
    GetPriceBreakdownlst: accountActions.GetPriceBreakdownlst
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(WinnerScroll))

